<template>
  <div
    v-show="songs.length"
    class="highlighted-songs"
  >
    <div class="header">
      <div class="level mb-0">
        <div class="level-left">
          <div>{{ title }}</div>
        </div>
        <div class="level-right">
          <b-select
            v-model="orderBy"
            size="is-small"
            icon="sort"
          >
            <option value="title">
              Title
            </option>
            <option value="artist_id">
              Artist
            </option>
            <option value="country_origin">
              Country
            </option>
            <option value="year">
              Year
            </option>
          </b-select>
          <button
            v-if="button"
            class="ml-5 button is-small is-dark"
            role="button"
            @click="$emit('closeButton')"
          >
            <span>{{ button }}</span>
            <span class="icon">
              <i class="mdi mdi-close" />
            </span>
          </button>
        </div>
      </div>
    </div>

    <div class="content">
      <table class="table is-fullwidth is-narrow">
        <thead>
          <th>Origin</th>
          <th />
          <th>Adaptation</th>
        </thead>
        <tbody>
          <tr
            v-for="(song) in orderedSongs"
            :key="song.id" 
            @mouseenter="$emit('hover', {source: song.country_origin, target: parentSong(song).country_origin})" 
            @mouseleave="$emit('hover', null)"
          >
            <td>
              <v-song-list-item
                :song="parentSong(song)"
                position="is-right" 
              />
            </td>
            <td>
              <div class="icon">
                <i class="mdi mdi-chevron-right" />
              </div>
            </td>
            <td>
              <v-song-list-item
                :song="song"
                position="is-left"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import SongListItem from "./SongListItem.vue";

export default {
	components: {
		"v-song-list-item": SongListItem
	},
	props: {
		songs: {
			required: true,
			type: Array
		},
		title: {
			required: true,
			type: String
		},
		button: {
			type: String
		},
		sortOnParent: {
			default: false,
			type: Boolean
		}
	},
	data () {
		return {
			orderBy: "title"
		};
	},
	computed: {
		orderedSongs () {
			return this.songs.slice(0,300).sort((a, b) => {

				if (this.sortOnParent) {
					a = this.parentSong(a);
					b = this.parentSong(b);
				}

				if (a[this.orderBy] > b[this.orderBy]) {
					return 1;
				}
				if (a[this.orderBy] < b[this.orderBy]) {
					return -1;
				}
				return 0;
			});
		},
	},
	methods: {
		parentSong (song) {
			return this.$store.state.songs[song.parent_id];
		}
	}
};
</script>
